import { leadershipImgs, s3Bucket } from ".";

export const techArr = () => [
    {
        name: "Aleena Ashary",
        img: leadershipImgs.aleena,
        title: "Director of Product",
    },
    {
        name: "Naomi Provost ",
        img: leadershipImgs.naomi,
        title: "Head of Engineering",
    },
    {
        name: "Liz Anderson",
        img: `${s3Bucket}landerson.jpg`,
        title: "Full Stack Engineer",
    },
    {
        name: "Ryan Becwar",
        img: `${s3Bucket}rbecwar.jpg`,
        title: "Infrastructure Engineer",
    },
    {
        name: "Javiera Canales",
        img: `${s3Bucket}jcanales.jpeg`,
        title: "Data Engineer",
    },
    { name: "Xinbo Lu", img: `${s3Bucket}xlu.jpg`, title: "Software Engineer" },
    {
        name: "Violet Moon",
        img: `${s3Bucket}vmoon.jpg`,
        title: "Frontend Engineer Lead",
    },
    {
        name: "Frank Mwangi",
        img: `${s3Bucket}fmwangi.jpg`,
        title: "Software Engineer ",
    },
];
